import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import { fetchAllBenefitsData } from "../../../redux/hygiene-reducers/hygieneSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { NoPic } from "../../../exports/Images";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { update_gym_benefit } from "../../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const GymBenefitsForm = ({
  userInfoData,
  closeModal,
  gymId,
  gymName,
  rowData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.postApi);
  const { allBenefitsLoading, allBenefits } = useSelector(
    (state) => state.hygiene
  );

  const initialCheckedUids = rowData.map((data) => data.uid);

  const [allDatas, setAllDatas] = useState([]);
  const [checkedItems, setCheckedItems] = useState(
    allDatas.map((item) => ({
      ...item,
      isChecked: initialCheckedUids.includes(item.uid),
    }))
  );
  const [isSubmit, setIsSubmit] = useState(false);

  const handleCheckboxChange = (index) => {
    setIsSubmit(false);
    const updatedCheckedItems = [...checkedItems];
    updatedCheckedItems[index].isChecked =
      !updatedCheckedItems[index].isChecked;
    setCheckedItems(updatedCheckedItems);
  };

  function getGymBenefits() {
    dispatch(
      fetchAllBenefitsData({
        filters: { status: "active" },
        token: userInfoData?.token,
      })
    );
  }

  const onSubmit = () => {
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "PUT";
    const endpoint = update_gym_benefit;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getGymBenefits();
  }, []);

  useEffect(() => {
    if (
      allBenefits?.status &&
      allBenefits?.data?.length > 0 &&
      !allBenefitsLoading
    ) {
      setAllDatas(allBenefits.data);
    } else {
      setAllDatas([]);
    }
  }, [allBenefits, allBenefitsLoading]);

  useEffect(() => {
    const initializedItems = allDatas.map((item) => ({
      ...item,
      isChecked: initialCheckedUids.includes(item.uid),
    }));

    setCheckedItems(initializedItems);
  }, [rowData, allDatas]);

  useEffect(() => {
    if (isSubmit) {
      const benefitsUid = checkedItems
        .filter((item) => item.isChecked)
        .map((item) => item.uid);

      const userData = {
        gym_id: gymId || "",
        benefits_uid: benefitsUid,
      };

      const handleConfirm = async () => {
        await handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Update ${gymName || ""} Benefits!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit]);

  return (
    <div className="createNewCTOModalContainer checkbox-form">
      <CommonHeadingNBtns
        title={"Manage Gym Benefits"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={loading}
      />

      {allBenefitsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <form className="gym-benefits-container mt30">
          {checkedItems.map((benefit, index) => (
            <div className="gym-benefit-box" key={benefit.id}>
              <div className="input-labels">
                <Form.Check
                  type={"checkbox"}
                  id={`checkbox-${index}`}
                  label={benefit?.name || "NA"}
                  className="checkbox-input"
                  checked={benefit.isChecked}
                  onChange={() => handleCheckboxChange(index)}
                />
              </div>
              <div className="horizontal-gay-line"></div>
              <img
                src={benefit?.image || NoPic}
                alt={benefit?.name || "N/A"}
                className="gym-benefit-image"
              />
            </div>
          ))}
        </form>
      )}
    </div>
  );
};

export default GymBenefitsForm;
